import React, { FC } from 'react';

import { userRiskFactorStyle } from './RiskFactor.style';

import { useGetRiskLevel } from '@/shared/hooks/useGetRiskLevel';
import { Skeleton } from '@/shared/ui';

export type RiskFactorBarProps = {
    health: number;
    marginCallThreshold: string | null;
    liquidationThreshold: string | null;
};

export const RiskFactorBar: FC<RiskFactorBarProps> = ({
    health,
    marginCallThreshold,
    liquidationThreshold,
}) => {
    const classes = userRiskFactorStyle();

    const loading = health === null;
    const { isHigh, isWarning, isLow, pivotHighRiskWithThreshold, pivotLowRisk } = useGetRiskLevel({
        health: health.toString(),
        marginCallThreshold: marginCallThreshold,
        liquidationThreshold: liquidationThreshold,
    });

    const formattedHealth = health?.toFixed(2);
    return (
        <div className={classes.placeholderBarWrapper}>
            {loading ? (
                <>
                    <Skeleton className={classes.small} />
                    <Skeleton className={classes.small} />
                    <Skeleton className={classes.small} />
                </>
            ) : (
                <>
                    <div className={classes.barWrapper}>
                        <div className={isHigh ? classes.errorBar : classes.emptyBar}>
                            <input
                                className={classes.slider}
                                type='range'
                                min='0'
                                max={pivotHighRiskWithThreshold!}
                                defaultValue={formattedHealth}
                                step='0.1'
                            />
                        </div>
                        <div>High</div>
                    </div>
                    <div className={classes.barWrapper}>
                        <div className={isWarning ? classes.warningBar : classes.emptyBar}>
                            <input
                                className={classes.slider}
                                type='range'
                                min={pivotHighRiskWithThreshold + 0.001}
                                max={pivotLowRisk}
                                defaultValue={formattedHealth}
                                step='0.1'
                            />
                        </div>
                        <div>Normal</div>
                    </div>
                    <div className={classes.barWrapper}>
                        <div className={isLow ? classes.successBar : classes.emptyBar}>
                            <input
                                className={classes.slider}
                                type='range'
                                min={pivotLowRisk + 0.001}
                                max='10'
                                defaultValue={formattedHealth}
                            />
                        </div>
                        <div>Low</div>
                    </div>
                </>
            )}
        </div>
    );
};
